<template>
  <div :class="$options.name">
    <v-dialog v-model="dialog" persistent max-width="340">
      <v-card>
        <v-card-title class="title" v-text="title" />
        <v-card-actions>
          <div class="flex-grow-1" />
          <v-btn color="error" text @click="dialog = false">Отмена</v-btn>
          <v-btn color="success" text @click="onConfirm">Удалить элемент</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import DialogBusMixin from '@/components/dialogs/mixins/dialog-bus-mixin';

export default {
  name: 'remove-confirmation',
  mixins: [DialogBusMixin],
  props: {
    title: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    itemId: null,
  }),
  methods: {
    beforeOpen({ itemId }) {
      this.itemId = itemId;
    },

    onConfirm() {
      this.$emit('confirmed', this.itemId);
      this.dialog = false;
    },
  },
};
</script>

<style lang="scss" scoped>

  .title {
    word-break: break-word;
  }
</style>
